/* Beskrivelsen på produktsiden: «Vis hele beskrivelsen» på mobil.

   Serveren har allerede lukket lange beskrivelser med CSS (gs-pd--lang), så
   siden ikke hopper når dette skriptet kommer. Her kobles knappen til, og
   lukkingen fjernes igjen om teksten likevel er så kort at den ville stått
   helt åpen: en knapp som ikke skjuler noe er bare støy.

   Hele teksten er i DOM-en hele tiden. Det er bare høyden som begrenses. */
(function () {
  'use strict';

  const start = () => {
    const seksjon = document.querySelector('[data-gs-pd]');
    if (!seksjon || !seksjon.classList.contains('gs-pd--lang')) return;

    const innhold = seksjon.querySelector('[data-gs-pd-innhold]');
    const knapp = seksjon.querySelector('[data-gs-pd-mer]');
    const tekst = seksjon.querySelector('[data-gs-pd-mer-tekst]');
    if (!innhold || !knapp || !tekst) return;

    const mobil = window.matchMedia('(max-width: 749px)');

    const apne = (apen) => {
      seksjon.classList.toggle('gs-pd--apen', apen);
      knapp.setAttribute('aria-expanded', apen ? 'true' : 'false');
      tekst.textContent = apen ? 'Vis mindre' : 'Vis hele beskrivelsen';
    };

    // Er teksten lengre enn den lukkede høyden? Måles åpen, så vi vet hele høyden.
    const tilpass = () => {
      if (!mobil.matches) return;
      const var_apen = seksjon.classList.contains('gs-pd--apen');
      seksjon.classList.add('gs-pd--apen');
      const hele = innhold.scrollHeight;
      if (!var_apen) seksjon.classList.remove('gs-pd--apen');
      const lukket = parseFloat(getComputedStyle(seksjon).getPropertyValue('--gs-pd-lukket')) * 10 || 300;
      const treng = hele > lukket + 60;
      seksjon.classList.toggle('gs-pd--lang', treng);
      knapp.hidden = !treng;
    };

    knapp.addEventListener('click', () => {
      const skalApnes = knapp.getAttribute('aria-expanded') !== 'true';
      apne(skalApnes);
      // Lukkes den igjen, skal kunden ikke bli stående midt i en lang side.
      if (!skalApnes) seksjon.scrollIntoView({ block: 'start' });
    });

    tilpass();
    mobil.addEventListener('change', tilpass);
    window.addEventListener('load', tilpass);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
